<template>
    <div class="container">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row col-md-12 mt-5">
            <div class="col-md-3 d-flex justify-content-end align-items-center">
                <h4>{{ labels.fechaIni }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="date" v-model="fechaIni" class="form-control">
            </div>
            <div class="col-md-3 d-flex justify-content-end align-items-center">
                <h4>{{ labels.fechaFin }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="date" v-model="fechaFin" class="form-control">
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="consultaReporte">{{ labels.consultar }}</b-button>
        </div>
        <div class="col-md-12 mt-3">
            <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
                <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="generaReporte()">
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                    </md-icon>
                </md-button>
            </div>
            <div class="row col-md-12 justify-content-center" v-if="lstContratos != 0">
                <b-table
                    :items="lstContratos"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                >
                    <template #cell(nro_contrato)="data">
                        <div class="text-right">{{ data.item.nro_contrato }}</div>
                    </template>
                    <template #cell(valor_contrato)="data">
                        <div class="text-right">{{ formatNumber(data.item.valor_contrato) }}</div>
                    </template>
                </b-table>
                <div class="row col-12">
                    <div class="col-10 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="lstContratos.length"
                        :per-page="perPage"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato';
import * as XLSX from "exceljs";

export default {
    name : 'InformacionContratos',
    data : () => ({
        btnGenExcel : false,
        lstContratos : [],
        fechaIni : '',
        fechaFin : '',
        perPage: 500,
        currentPage: 1,
        fields: [
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'arrendador', label: 'Arrendador', sortable: false },
            { key: 'tipo_contrato', label: 'Tipo contrato', sortable: false },
            { key: 'valor_contrato', label: 'Valor contrato', sortable: false },
            { key: 'fecha_activacion', label: 'Fecha activación', sortable: false },
            { key: 'fecha_inicial', label: 'Fecha inicial', sortable: false },
            { key: 'fecha_final', label: 'Fecha final', sortable: false },
            { key: 'estado', label: 'Estado', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Información contratos",
                    fechaIni: 'Desde',
                    fechaFin: 'Hasta',
                    consultar: 'Consultar',
                    nroContrato : 'Contrato',
                    arrendador : 'Arrendador',
                    tipoContrato : 'Tipo contrato',
                    valContrato : 'Valor contrato',
                    fechActivacion : 'Fecha activación',
                    fechInicial : 'Fecha inicial',
                    fechFin : 'Fecha fin',
                    state : 'Estado',
                }
            }else{
                return {
                    title: "Contract information",
                    fechaIni: 'From',
                    fechaFin: 'Until',
                    consultar: 'Consult',
                    nroContrato : 'Contract',
                    arrendador : 'Lessor',
                    tipoContrato : 'Contract type',
                    valContrato : 'Contract value',
                    fechActivacion : 'Activation date',
                    fechInicial : 'Starting date',
                    fechFin : 'End date',
                    state : 'State',
                }
            }
        }
    },
    methods:{
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
        },
        consultaReporte(){
            if(this.fechaIni == '' || this.fechaFin == ''){
                this.$toast.error('Diligenciar la fecha.');
            }else{
                Contrato.getContratosByFechaInicio_FechaFin(this.fechaIni,this.fechaFin)
                .then((res) => {
                    // console.log(res.data.qryContratos);
                    this.lstContratos = res.data.qryContratos
                    
                    if(this.lstContratos.length != 0){
                        this.lstContratos = res.data.qryContratos
                        this.btnGenExcel = true
                    }else{
                        this.$toast.error('No hay registros para la fecha seleccionada.')
                        this.btnGenExcel = false
                    }
                })
                .catch((err) => { console.log(err)})
            }
        },
        async generaReporte(){

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Lista de contratos")

            const titulo = ['Lista de contratos']
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:H1')
            worksheet.getCell('A1').font = { name: 'Arial', bold : true, size : 12};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            const infoContrato = worksheet.addRow([
                'Desde:',
                this.fechaIni,
                'Hasta:',
                this.fechaFin
            ])
            worksheet.mergeCells('E2:H2')

            // Negrita a etiquetas
            infoContrato.getCell(1).font = { name: 'Arial', size: 12, bold: true }
            infoContrato.getCell(3).font = { name: 'Arial', size: 12, bold: true }

            const headerRow = worksheet.addRow([
                'Contrato',
                'Arrendador',
                'Tipo contrato',
                'Valor contrato',
                'Fecha activación',
                'Fecha inicial',
                'Fecha fin',
                'Estado'
            ])

            // Estilo de títulos
            headerRow.eachCell(cell => {
                cell.font = { name: 'Arial', size: 12, bold: true }
                cell.alignment = { horizontal: 'center' }
            })

            this.lstContratos.map((e) => {
                worksheet.addRow([
                    e.nro_contrato,
                    e.arrendador,
                    e.tipo_contrato,
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.valor_contrato),
                    e.fecha_activacion,
                    e.fecha_inicial,
                    e.fecha_final,
                    e.estado
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }

            for( let row = 1; row <= worksheet.rowCount; row++){
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Lista de contratos.xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();
        }
    }
}
</script>

<style src="../main.css">
</style>